import React from 'react';
import { Caption, HeadingSBold } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';
import NoBundle from './NoBundle';
import Unlimited from './Unlimited';
import CustomLinearProgress from 'components/CustomLinearProgress/CustomLinearProgress';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBundleLeftProps {
	header: string;
	data: any;
	hideUnit?: boolean;
	noPackageText?: string;
	unlimitedText?: string;
	warning?: boolean;
	message?: string;
}

const BundleLeft = ({ header, data, hideUnit, noPackageText, unlimitedText, warning, message }: IBundleLeftProps) => {
	const classes = useStyles();

	if (!data) {
		return <NoBundle text={noPackageText} />;
	}
	if (data.unlimited) {
		// TODO
		return <Unlimited subheader={unlimitedText || ''} />;
	}

	return (
		<div className={classes.bundleContainer}>
			<div className={classes.header}>
				<Caption color="disabled-light" disableMargin>
					{header}
				</Caption>
			</div>
			<div className={classes.leftBundleNumber}>
				<div className={classes.leftBundle}>
					<HeadingSBold inline>{data.totalBalance.value}</HeadingSBold>
					<span className={classes.unit}>{data.totalBalance.unit}</span>
				</div>
				<div className={classes.allBundle}>
					<HeadingSBold color="disabled-light" inline>
						<>
							/ {data.totalPackageSize.value}
							{!hideUnit && data.totalPackageSize.unit}
						</>
					</HeadingSBold>
				</div>
			</div>
			<div>
				<CustomLinearProgress
					variant="determinate"
					color={warning ? 'danger' : 'primary'}
					value={100 - data.usedPercentage}
					className={classes.balanceProgress}
				/>
			</div>
			<ConditionalRender
				show={!!message}
				onTrue={() => <Caption color={warning ? 'danger' : 'primary-light'}>{message}</Caption>}
			/>
		</div>
	);
};

export default BundleLeft;
